import React from "react";

const WarrantyVehicleTable = () => {
    // ["Category", "Supreme", "Elite", "5 Layer", "Proguard"],
    const data = [
        ["CAR COVERS", "$55.00", "$45.00", "$40.00", "$35.00"],
        ["TRUCK COVERS", "$60.00", "$55.00", "$50.00", "$45.00"],
        ["SUV COVERS", "$60.00", "$55.00", "$50.00", "$45.00"],
    ];
    const images = [
        null,
        "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/4a93f6a9b7247710787b47c62083e1573ef80660.png?v=1766069783",
        "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/96ba6234e09a9935ea5abf9e551ba6f610f1e763.png?v=1766069783",
        "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/8b850f705bab7b5e4a95d353198af7053a7b0c47.png?v=1766069783",
        "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/2-Year_Warranty.svg?v=1767013823",

    ]
    return (
        <div className="table-block table-block--warranty-vehicle">
            <div className="table-block">
                <div className="table-block__header">
                    <div className="table-block__header-cell table-block__header-cell--category">Category</div>
                    <div className="table-block__header-cell table-block__header-cell--supreme">Supreme</div>
                    <div className="table-block__header-cell table-block__header-cell--elite">Elite</div>
                    <div className="table-block__header-cell table-block__header-cell--5-layer">5 Layer</div>
                    <div className="table-block__header-cell table-block__header-cell--proguard">Proguard</div>
                </div>

                {/* <div className="table-block__row">
                    <div className="table-block__cell">Waterproof</div>
                    <div className="table-block__cell">Waterproof</div>
                </div> */}
                {data.map((row, index) => (
                    <div className="table-block__row" key={index}>
                        <div className="table-block__cell">{row[0]}</div>
                        <div className="table-block__cell">{row[1]}</div>
                        <div className="table-block__cell">{row[2]}</div>
                        <div className="table-block__cell">{row[3]}</div>
                        <div className="table-block__cell">{row[4]}</div>
                    </div>
                ))}

                <div className="table-block__row">
                    {images.map((row, index) => (
                        <div className="table-block__cell table-block__cell--padding-none" key={index}>
                            {row ? <div className="table-block__warranty-badge-container"> <img className="table-block__warranty-badge" src={row} alt={row} /> </div   > : null}
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default WarrantyVehicleTable;

